import { createFileRoute } from '@tanstack/react-router';

import { SitesPage } from '@/areas/settings/manufacturing/Settings/SitesPage/SitesPage';
import { canViewSitesSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/sites')({
    staticData: {
        access: { permissions: canViewSitesSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SitesPage />;
}
